import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { useStyles, styles } from '../../UserSearchScreenStyles';
import { Icon, Table, Tooltip, Modal, Row, Col, Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import * as UserSearchActions from 'app/actions/UserSearchActions';
import { useState } from 'react';

const InternalEmployeesTableComponent = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    //Datos del store de redux
    const {
        listInternalEmployees,
        isLoadingInternalEmployees,

        filter,
        pagination
    } = useSelector(state => state.UserSearchReducer);

    //destructiracion de la paginación
    const { current, pageSize, total } = pagination;

    //Crear datasource de la tabla con la propiedad 'key'
    const dataSource = listInternalEmployees.map((record) => {
        return {
            'key': record.employeeId,
            ...record
        }

    });

    //Datos para usar en la paginación
    const paginationTable =
    {
        defaultCurrent: 1,
        defaultPageSize: 25,
        current: current,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['25', '50', '100'],
        showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    }

    //Funcion que maneja los cambios en la tabla (Ordenamiento)
    const handleTableChange = (pagination, filters, sorter) => {
        
        let obj = {
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            column: Object.keys(sorter).length > 0 ? sorter.field : undefined,
            order: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : undefined
        }
        dispatch(UserSearchActions.savePagination(obj));

        dispatch(UserSearchActions.fetchInternalEmployees({
            offset: (pagination.current - 1) * pagination.pageSize,
            limit: pagination.pageSize,
            sortColumn: Object.keys(sorter).length > 0 ? sorter.field : '',
            sortDir: Object.keys(sorter).length > 0 ? (sorter.order === "ascend" ? 'ASC' : 'DESC') : '',
            listSubdirections: filter.listInternalEmployeesSubdirection.length > 0 ? filter.listInternalEmployeesSubdirection.join("|") : '',
            listNames: filter.listInternalEmployeesNames.length > 0 ? filter.listInternalEmployeesNames.join("|") : '',
            listFiles: filter.listInternalEmployeesId.length > 0 ? filter.listInternalEmployeesId.join("|") : '',
            listCompanys: filter.listInternalEmployeesCompany.length > 0 ? filter.listInternalEmployeesCompany.join("|") : '',
            listJobs: filter.listInternalEmployeesCategory.length > 0 ? filter.listInternalEmployeesCategory.join("|") : '',
            listContracts: filter.listInternalEmployeesContract.length > 0 ? filter.listInternalEmployeesContract.join("|") : '',
            listOTs: filter.listInternalEmployeesOT.length > 0 ? filter.listInternalEmployeesOT.join("|") : '',
            listEmails: filter.listInternalEmployeesEmail.length > 0 ? filter.listInternalEmployeesEmail.join("|") : '',
            listCeco: filter.listInternalEmployeesCeco.length > 0 ? filter.listInternalEmployeesCeco.join("|") : '',
            listEpep: filter.listInternalEmployeesEpep.length > 0 ? filter.listInternalEmployeesEpep.join("|") : '',
            listIsActive: filter.listIsActive.length > 0 ? filter.listIsActive.join("|") : '',
            listPernocta: filter.listPercnota.length > 0 ? filter.listPercnota.join("|") : '',
        }));
    }

    //Funcion para mostrar kardex
    const showKardex = (record) => {
        if (record.hasCommunications) {
            props.showKardex(true);
            props.setEmployeeId(record.employeeId);
            props.setIsExternal(false);
        } else {
            showModalFunc();
        }
    }

    //Mostrar modal si no existen comunicaciones
    const showModalFunc = () => {
        Modal.info({
            title: 'Sin comunicaciones existentes',
            content: (
                <div>
                    <p>El colaborador seleccionado no cuenta con comunicaciones</p>
                </div>
            ),
            onOk() {
                Modal.destroyAll();
            },
        });
    }

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    //Definición de columnas de la tabla
    const columns = [
        {
            title: 'Subdirección',
            dataIndex: 'subdirectionName',
            key: 'subdirectionName',
            sorter: true,
            ellipsis: true,
            width: 150,
        },
        {
            title: 'CeCo',
            dataIndex: 'ceCo',
            key: 'ceCo',
            sorter: true,
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            ellipsis: true,
            width: 250,
        },
        {
            title: 'Ficha',
            dataIndex: 'file',
            key: 'file',
            sorter: true,
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Puesto',
            dataIndex: 'job',
            key: 'job',
            sorter: true,
            ellipsis: true,
            width: 400,
        },
        {
            title: 'Pernocta',
            dataIndex: 'pernocta',
            key: 'pernocta',
            sorter: true,
            ellipsis: true,
            width: 300,
        },
        {
            title: 'Compañia',
            dataIndex: 'company',
            key: 'company',
            sorter: true,
            ellipsis: true,
            width: 400,
        },
        {
            title: 'EPEP',
            dataIndex: 'epep',
            key: 'epep',
            sorter: true,
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Contrato',
            dataIndex: 'contractName',
            key: 'contractName',
            sorter: true,
            ellipsis: true,
            width: 150,
        },
        {
            title: 'OT',
            dataIndex: 'ot',
            key: 'ot',
            sorter: true,
            ellipsis: true,
            width: 150,
        },
        {
            title: 'Activo',
            key: 'active',
            dataIndex: 'isActive',
            width: 150,
            sorter: true,
            render: (text, record) => (
                <Row>
                    <Col offset={4}>
                        <Badge status={record.isActive ? "success" : "error"} />
                    </Col>
                </Row>
            )
        },
        {
            width: '100%'
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'employeeId',
            fixed: 'right',
            // width: '100%',
            render: (text, record) => (
                <div className={classes.buttons}>
                    <Tooltip placement="bottom" title={'Mostrar Kardex'}>
                        <IconButton onClick={() => showKardex(record)}>
                            <Icon type="profile" />
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    return (
        <Table
            loading={isLoadingInternalEmployees}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationTable}
            // scroll={{ y: 700, x: "min-content" }}
            scroll={{ x: 'min-content', y: (height - 395) }}
            onChange={handleTableChange}
            size="small"
        />
    )
}

export default InternalEmployeesTableComponent;
